import React, { useContext } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  makeStyles,
} from '@material-ui/core';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../../context/Auth/AuthContext';
import { BLOCK_REASON_MESSAGES, BLOCK_REASON_TITLES } from '../../types/company';

const useStyles = makeStyles((theme) => ({
  iconWrapper: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(2),
  },
  icon: {
    fontSize: 64,
    color: theme.palette.warning.main,
  },
  message: {
    textAlign: 'center',
    color: theme.palette.text.secondary,
    lineHeight: 1.6,
    marginBottom: theme.spacing(1),
  },
  button: {
    borderRadius: 12,
  },
}));

/**
 * Deriva o motivo de bloqueio de user.company.status (novo backend).
 * Fallback para mensagem genérica durante migração.
 */
const getBlockInfo = (companyStatus) => {
  if (companyStatus === 'cancelled') {
    return {
      title: BLOCK_REASON_TITLES.SUBSCRIPTION_CANCELLED,
      message: BLOCK_REASON_MESSAGES.SUBSCRIPTION_CANCELLED,
    };
  }
  if (companyStatus === 'inactive') {
    return {
      title: BLOCK_REASON_TITLES.COMPANY_INACTIVE,
      message: BLOCK_REASON_MESSAGES.COMPANY_INACTIVE,
    };
  }
  // trial expirado ou status desconhecido
  return {
    title: 'Acesso bloqueado',
    message:
      'Sua conta está com acesso bloqueado. Regularize sua assinatura para continuar usando o sistema.',
  };
};

const BlockedModal = ({ open, onClose }) => {
  const classes = useStyles();
  const history = useHistory();
  const { user } = useContext(AuthContext);

  const companyStatus = user?.company?.status;
  const { title, message } = getBlockInfo(companyStatus);

  const handleGoToPlans = () => {
    onClose();
    history.push('/subscription/plans');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle disableTypography>
        <Typography variant="h6" component="div" align="center" style={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box className={classes.iconWrapper}>
          <WarningAmberIcon className={classes.icon} />
        </Box>
        <Typography className={classes.message}>{message}</Typography>
        <Typography className={classes.message} style={{ fontWeight: 500, marginTop: 16 }}>
          Escolha um plano ou entre em contato com o suporte para recuperar o acesso.
        </Typography>
      </DialogContent>
      <DialogActions style={{ justifyContent: 'center', paddingBottom: 24, gap: 8 }}>
        <Button variant="outlined" onClick={onClose} className={classes.button}>
          Fechar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoToPlans}
          className={classes.button}
        >
          Ver planos
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BlockedModal;
